import { useState, useEffect } from 'react';
import { GroupTagPicker } from '../../../components/Protected/GroupTagPicker';
import { useQuery, gql } from '@apollo/client';

const GET_ORGANISATION_COURSE_ID_FORMULA = gql`
query Organisation {
    me {
        organisation {
            courseIdentifierFormula
        }
    }
}`;

interface IProps {
    setSku: (sku: string) => void;
    setTagIds: (ids: number[]) => void;
    showErrors: boolean;
    initialSKU?: string;
}

const CourseSKUPicker = ({
    setSku,
    setTagIds,
    showErrors,
    initialSKU,
}: IProps) => {
    const { loading, data } = useQuery(GET_ORGANISATION_COURSE_ID_FORMULA);

    const [skuParts, setSkuParts] = useState<any[]>([]);

    useEffect(() => {
        if (data) {
            const formula = data.me.organisation.courseIdentifierFormula;
            const groupIds = formula.split(',').map((part: string) => parseInt(part, 10));

            const initialParts = initialSKU ? initialSKU.split('-') : [];

            const newSkuParts = groupIds.map((groupId: any, index: number) => {
                return {
                    groupId,
                    tagId: 0,
                    value: initialParts[index] || 'XX'
                };
            });

            setSkuParts(newSkuParts);
        }
    }, [data, initialSKU]);

    if (loading) return <p>Loading...</p>;

    const handleUpdate = (s: string, groupId: number, tagId: number) => {
        const newSkuParts = skuParts.map((skuPart) => {
            if (skuPart.groupId === groupId) {
                return {
                    ...skuPart,
                    tagId,
                    value: s
                };
            }
            return skuPart;
        });

        setSkuParts(newSkuParts);
        setTagIds(newSkuParts.filter((skuPart) => skuPart.tagId).map((skuPart) => skuPart.tagId));
        setSku(newSkuParts.map((skuPart) => skuPart.value).join('-'));
    };

    return (
        <>
            {skuParts.map(({ groupId, value }) => (
                <GroupTagPicker
                    key={groupId}
                    showErrors={showErrors}
                    groupId={groupId}
                    initialValue={value}
                    setValue={handleUpdate}
                />
            ))}
            <br/>
        </>
    );
};

export { CourseSKUPicker };
